import React, { useMemo } from 'react';
import SingleTreatmentSelector from './SingleTreatmentSelector';
import {Grid } from '@mui/material';
import SmartField from './';
import { ButtonContinue } from '../mini_components';
import { Translate } from 'react-localize-redux';
import { green } from '@mui/material/colors';
import { useSnackBarState } from "../../../hooks";
import { Snackbar, Alert } from '@mui/material';
import ClinicalSummaryBanner from '../ClinicalSummary/ClinicalSummaryBanner';

interface TreatmentInpatientSelectionProps {
  variant?: "standard" | "filled" | "outlined" | undefined;
  size?: string;
  language: string;
  typeMargin?: any;
  type: string;
  slaves?: object[];
  country?: string;
  template?: string;
  cancel?: () => void;
  updateElement?: (index: number, element: any) => void;
  elementSelected: (element: any) => void;
  onSave?: (treatments: any[]) => void;
  error: boolean;
  initialTreatments?: Array<any>;
  fieldInfo?: any;
  uuidSurvey?: string;
  uuidPatient?: string;
  uuidInvestigation?: string;
  idSubmission?: number;
  onSaveToDatabase?: (treatmentData: any) => Promise<void>;
  onUpdateDatabase?: (treatmentData: any) => Promise<void>;
  onDeleteDatabase?: (treatmentData: any) => Promise<void>;
}

function TreatmentInpatientSelection(props: TreatmentInpatientSelectionProps) {
  //return <SingleTreatmentSelector {...props} type="treatment_inpatient" />;

  // Memoize initialState to prevent infinite render loop:
  // Without this, a new object is created every render, which triggers
  // useUpdateEffect([props.initialState]) in SmartField, which calls setListElements,
  // which triggers elementSelected -> input.onChange -> parent re-render -> new object -> loop
  const initialState = useMemo(() => ({
    listElements: props.initialTreatments,
    addingElements: false
  }), [props.initialTreatments]);

  return (

    <>
      {/* SHER-263: Clinical Summary (allergies) above inpatient med selection. */}
      <ClinicalSummaryBanner uuidInvestigation={props.uuidInvestigation || ""} uuidPatient={props.uuidPatient || ""} />
      <SmartField
        type="treatment_inpatient"
        mode="form"
        initialState={initialState as any}
        printMode={false}
        label="Treatment"
        name="treatment_inpatient"
        typeMargin={props.typeMargin}
        forceDisplayElements={true}
        slaves={props.slaves || []}
        error={props.error}
        language={props.language}
        elementSelected={props.elementSelected}
        country={props.country || ""}
        fieldInfo={props.fieldInfo}
        uuidSurvey={props.uuidSurvey}
        uuidPatient={props.uuidPatient}
        uuidInvestigation={props.uuidInvestigation}
        idSubmission={props.idSubmission}
        onSaveToDatabase={props.onSaveToDatabase}
        onUpdateDatabase={props.onUpdateDatabase}
        onDeleteDatabase={props.onDeleteDatabase}
        updateElement={props.updateElement}
      />
  </>

  );
}

export default TreatmentInpatientSelection;